export const DEFAULT_KUULA_PARAMS = {
  logo: "0",
  info: "1",
  fs: "1",
  vr: "0",
  zoom: "1",
  autorotate: "0.89",
  autop: "6",
  autopalt: "1",
  thumbs: "0",
} as const;

export type KuulaOverrides = Partial<Record<keyof typeof DEFAULT_KUULA_PARAMS, string>>;

export function isKuulaUrl(url: string): boolean {
  try {
    return new URL(url).hostname.toLowerCase().includes("kuula.co");
  } catch {
    return false;
  }
}

export function applyKuulaBranding(url: string, overrides: KuulaOverrides = {}): string {
  try {
    const parsed = new URL(url);
    if (!parsed.hostname.toLowerCase().includes("kuula.co")) {
      return url;
    }

    const params = { ...DEFAULT_KUULA_PARAMS, ...overrides };
    Object.entries(params).forEach(([key, value]) => parsed.searchParams.set(key, value));
    return parsed.toString();
  } catch {
    return url;
  }
}